import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const drawerOpenKey = 'drawerOpened';
function getDrawerState() {
    const state = localStorage.getItem(drawerOpenKey);
    if (state) {
        return state === 'true';
    }
    // `true` indicates that the default value is open.
    return true;
}
function saveDrawerState(state) {
    return localStorage.setItem(drawerOpenKey, state.toString());
}
const PageMenuDrawerContext = React.createContext({
    open: undefined,
    close: undefined,
    toggle: undefined,
    isOpen: false,
});
function PageMenuDrawerProvider({ children }) {
    const theme = useTheme();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const [drawerOpen, setDrawerOpen] = React.useState(isBigScreen && getDrawerState());
    const openDrawer = React.useCallback(() => setDrawerOpen(true), []);
    const closeDrawer = React.useCallback(() => setDrawerOpen(false), []);
    const toggleDrawer = React.useCallback(() => setDrawerOpen(!drawerOpen), [drawerOpen]);
    const provided = {
        open: openDrawer,
        close: closeDrawer,
        toggle: toggleDrawer,
        isOpen: drawerOpen,
    };
    React.useEffect(() => saveDrawerState(drawerOpen), [drawerOpen]);
    return React.createElement(PageMenuDrawerContext.Provider, { value: provided }, children);
}
export { PageMenuDrawerContext, PageMenuDrawerProvider };
